import React, { useState } from 'react';
import { X } from 'lucide-react';
import API_BASE_URL from '../services/api';
import axios from 'axios';

const NewDoctorModal = ({ isOpen, onClose, onSave }) => {
  const [formData, setFormData] = useState({
 
    initial: 'Dr.',
    name: '',
    qualification: '',
    specialityType: '',
    speciality: '',
    mobile: '',
    landLine: '',
    email: '',
    venue: '',
    refCenter: '',
    source: '',
    address: '',
    otherInfo: '',
   
  });

  if (!isOpen) return null;

  const handleChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

const handleSubmit = async (e) => {
  e.preventDefault();

  try {
    // Auto-generate unique doctor number (required in backend)
    const doctorNumber = "DOC" + Date.now();

    const payload = {
      ...formData,
      number: doctorNumber, 
    };

    const response = await axios.post(
      `${API_BASE_URL}/api/doctors`,
      payload
    );

    if (response.status === 201) {
      onSave(response.data.doctor);
      onClose();
    }

  } catch (error) {
    console.error("Create doctor failed:", error);
    alert(error.response?.data?.message || "Failed to save doctor");
  }
};


  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="flex items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
        {/* Overlay */}
        <div className="fixed inset-0 transition-opacity bg-gray-500 bg-opacity-75" onClick={onClose}></div>

        {/* Modal */}
        <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
          <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
            {/* Header */}
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-lg font-semibold text-gray-900">New Doctor</h3>
              <button
                onClick={onClose}
                className="text-gray-400 hover:text-gray-500"
              >
                <X className="w-5 h-5" />
              </button>
            </div>

            <form onSubmit={handleSubmit}>
              <div className="space-y-4">
                
               

                {/* Initial Name * */}
                <div>
                  <label className="block text-xs font-medium text-gray-700 mb-1">
                    Initial Name <span className="text-red-500">*</span>
                  </label>
                  <div className="flex gap-2">
                    <select
                      value={formData.initial}
                      onChange={(e) => handleChange('initial', e.target.value)}
                      className="w-1/4 px-3 py-2 border border-gray-300 rounded text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    >
                      <option>Dr.</option>
                     
                    </select>
                    <div>
                   
                    <label className="block text-xs font-medium text-gray-700 mb-1">Name</label>
                    <input
                      type="text"
                      value={formData.name}
                      label="Name"
                      onChange={(e) => handleChange('name', e.target.value)}
                      className="flex-1 px-3 py-2 border border-gray-300 rounded text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    
                      required
                    /> </div>
                  </div>
                </div>

                {/* Qualification */}
                <div>
                  <label className="block text-xs font-medium text-gray-700 mb-1">Qualification</label>
                  <input
                    type="text"
                    value={formData.qualification}
                    onChange={(e) => handleChange('qualification', e.target.value)}
                    className="w-full px-3 py-2 border border-gray-300 rounded text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                   
                  />
                </div>

                {/* Speciality */}
                <div className="grid grid-cols-2 gap-3">
                  <div>
                    <label className="block text-xs font-medium text-gray-700 mb-1">Speciality Type</label>
                    <select
                      value={formData.specialityType}
                      onChange={(e) => handleChange('specialityType', e.target.value)}
                      className="w-full px-3 py-2 border border-gray-300 rounded text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    >
                      <option value="">Select Type</option>
                      <option value="cardiology">Cardiology</option>
                      <option value="neurology">Neurology</option>
                      <option value="orthopedics">Orthopedics</option>
                      <option value="pediatrics">Pediatrics</option>
                      <option value="general">General</option>
                    </select>
                  </div>
                  <div>
                    <label className="block text-xs font-medium text-gray-700 mb-1">Speciality</label>
                    <select
                      value={formData.speciality}
                      onChange={(e) => handleChange('speciality', e.target.value)}
                      className="w-full px-3 py-2 border border-gray-300 rounded text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    >
                      <option value="">Select Speciality</option>
                      <option value="cardiologist">Cardiologist</option>
                      <option value="neurologist">Neurologist</option>
                      <option value="orthopedic">Orthopedic Surgeon</option>
                      <option value="pediatrician">Pediatrician</option>
                      <option value="physician">General Physician</option>
                    </select>
                  </div>
                </div>

                {/* Contact Information */}
                <div className="grid grid-cols-2 gap-3">
                  <div>
                    <label className="block text-xs font-medium text-gray-700 mb-1">Mobile</label>
                    <input
                      type="tel"
                      value={formData.mobile}
                      onChange={(e) => handleChange('mobile', e.target.value)}
                      className="w-full px-3 py-2 border border-gray-300 rounded text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    
                    />
                  </div>
                  <div>
                    <label className="block text-xs font-medium text-gray-700 mb-1">Land line</label>
                    <input
                      type="text"
                      value={formData.landLine}
                      onChange={(e) => handleChange('landLine', e.target.value)}
                      className="w-full px-3 py-2 border border-gray-300 rounded text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                
                    />
                  </div>
                </div>

                {/* Email & Venue */}
                <div className="grid grid-cols-2 gap-3">
                  <div>
                    <label className="block text-xs font-medium text-gray-700 mb-1">Email</label>
                    <input
                      type="email"
                      value={formData.email}
                      onChange={(e) => handleChange('email', e.target.value)}
                      className="w-full px-3 py-2 border border-gray-300 rounded text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                     
                    />
                  </div>
                    <div>
                    <label className="block text-xs font-medium text-gray-700 mb-1">Source</label>
                    <input
                      type="text"
                      value={formData.source}
                      onChange={(e) => handleChange('source', e.target.value)}
                      className="w-full px-3 py-2 border border-gray-300 rounded text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                     
                    />
                  </div>
                
                </div>

                

                {/* Address */}
                <div>
                  <label className="block text-xs font-medium text-gray-700 mb-1">Address</label>
                  <textarea
                    value={formData.address}
                    onChange={(e) => handleChange('address', e.target.value)}
                    rows="2"
                    className="w-full px-3 py-2 border border-gray-300 rounded text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 resize-none"
                
                  />
                </div>

                {/* Other Information */}
                <div>
                  <label className="block text-xs font-medium text-gray-700 mb-1">Other information</label>
                  <textarea
                    value={formData.otherInfo}
                    onChange={(e) => handleChange('otherInfo', e.target.value)}
                    rows="2"
                    className="w-full px-3 py-2 border border-gray-300 rounded text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 resize-none"
                  
                  />
                </div>

               
              </div>

              {/* Footer Buttons */}
              <div className="mt-6 flex justify-end gap-3">
                <button
                  type="button"
                  onClick={onClose}
                  className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 border border-gray-300 rounded-md hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                >
                  Close
                </button>
                <button
                  type="submit"
                  className="px-4 py-2 text-sm font-medium text-white bg-blue-600 border border-transparent rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                >
                  Save Doctor
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewDoctorModal;